import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { createAction, props } from '@ngrx/store';
import {
  AppUser,
  CreateCompanyManager,
  GetAllUsersResponse,
  GetUserDetailsResponse,
  updateUser,
} from '../../domain/entities/user.entity';

/**
 * Actions For All Users
 */
export const getAllUsersAction = createAction(
  '[Users] Get All Users Action',
  props<{
    companyId: string;
  }>()
);
export const getAllUsersSuccessAction = createAction(
  '[Users] Get All Users Success Action',
  props<{
    users: GetAllUsersResponse;
  }>()
);
export const getAllUsersFailureAction = createAction(
  '[Users] Get All Users Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For All Users
 */
export const getUserDetailsAction = createAction(
  '[Users] Get Users Details Action',
  props<{
    userId: string;
  }>()
);
export const getUserDetailsSuccessAction = createAction(
  '[Users] Get Users Details Success Action',
  props<{
    user: GetUserDetailsResponse;
  }>()
);
export const getUserDetailsFailureAction = createAction(
  '[Users] Get Users Details Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Send Link
 */
export const sendLinkAction = createAction('[Users] Send Link Action');
export const sendLinkSuccessAction = createAction(
  '[Users] Send Link Success Action',
  props<{
    response: any;
  }>()
);
export const sendLinkFailureAction = createAction(
  '[Users] Send Link Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Upload File
 */
export const uploadFileAction = createAction(
  '[Users] Upload File Action',
  props<{
    file: any;
  }>()
);
export const uploadFileSuccessAction = createAction(
  '[Users] Upload File Success Action',
  props<{
    response: any;
  }>()
);
export const uploadFileFailureAction = createAction(
  '[Users] Upload File Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Get Users Count
 */
export const getUsersCountAction = createAction(
  '[Users] Get Users Count Action',
  props<{
    companyId: any;
  }>()
);
export const getUsersCountSuccessAction = createAction(
  '[Users] Get Users Count Success Action',
  props<{
    response: any;
  }>()
);
export const getUsersCountFailureAction = createAction(
  '[Users] Get Users Count Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Get Users Count
 */
export const updateUserAction = createAction(
  '[Users] Update User Action',
  props<{
    userId: any;
    userData: updateUser;
  }>()
);
export const updateUserSuccessAction = createAction(
  '[Users] Update User Success Action',
  props<{
    response: any;
  }>()
);
export const updateUserFailureAction = createAction(
  '[Users] Update User Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Delete User
 */
export const deleteUserAction = createAction(
  '[Users] Delete User Action',
  props<{
    userId: any;
  }>()
);
export const deleteUserSuccessAction = createAction(
  '[Users] Delete User Success Action',
  props<{
    response: any;
  }>()
);
export const deleteUserFailureAction = createAction(
  '[Users] Delete User Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Delete User
 */
export const forgotPasswordAction = createAction(
  '[Users] Forgot Password Action',
  props<{
    emailOrUsername: any;
  }>()
);
export const forgotPasswordSuccessAction = createAction(
  '[Users] Forgot Password Success Action',
  props<{
    response: any;
  }>()
);
export const forgotPasswordFailureAction = createAction(
  '[Users] Forgot Password Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Delete User
 */
export const resetPasswordAction = createAction(
  '[Users] Reset Password Action',
  props<{
    resetPasswordData: any;
  }>()
);
export const resetPasswordSuccessAction = createAction(
  '[Users] Reset Password Success Action',
  props<{
    response: any;
  }>()
);
export const resetPasswordFailureAction = createAction(
  '[Users] Reset Password Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update Company Manager
 */
export const updateCompanyManagerAction = createAction(
  '[Users] Update Company Manager Action',
  props<{
    userData: any;
  }>()
);
export const updateCompanyManagerSuccessAction = createAction(
  '[Users] Update Company Manager Success Action',
  props<{
    response: any;
  }>()
);
export const updateCompanyManagerFailureAction = createAction(
  '[Users] Update Company Manager Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Confirm Account
 */
export const confirmAccountAction = createAction(
  '[Users] Confirm Account Action',
  props<{
    confirmAccountToken: string;
  }>()
);
export const confirmAccountSuccessAction = createAction(
  '[Users] Confirm Account Success Action',
  props<{
    response: any;
  }>()
);
export const confirmAccountFailureAction = createAction(
  '[Users] Confirm Account Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Action For Switch Admin | regular user
 */
export const switchToAdminAction = createAction(
  '[Users] Switch To Admin Action',
  props<{
    status: boolean;
  }>()
);
/**
 * Actions For Create Company Manager
 */
export const createCompanyManagerAction = createAction(
  '[Users] Create Company Manager Action',
  props<{
    data: CreateCompanyManager;
  }>()
);
export const createCompanyManagerSuccessAction = createAction(
  '[Users] Create Company Manager Success Action',
  props<{
    response: {
      authToken: string;
      refreshToken: string;
      user: AppUser;
    };
  }>()
);
export const createCompanyManagerFailureAction = createAction(
  '[Users] Create Company Manager Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Resend Email
 */
export const resendEmailAction = createAction('[Users] Resend Actions Action');
export const resendEmailSuccessAction = createAction(
  '[Users] Resend Actions Success Action',
  props<{
    response: any;
  }>()
);
export const resendEmailFailureAction = createAction(
  '[Users] Resend Actions Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Send Code (V1)
 */
export const sendCodeAction = createAction(
  '[Users] Send Code Action',
  props<{
    email: string;
    password?: string;
  }>()
);
export const sendCodeSuccessAction = createAction(
  '[Users] Send Code Success Action',
  props<{
    response: any;
  }>()
);
export const sendCodeFailureAction = createAction(
  '[Users] Send Code Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Verify Auth Token
 */
export const verifyAuthTokenAction = createAction(
  '[Users] Verify Auth Token Action',
  props<{
    confirmAccountToken: string;
  }>()
);
export const verifyAuthTokenSuccessAction = createAction(
  '[Users] Verify Auth Token Success Action',
  props<{
    response: {
      authToken: string;
      refreshToken: string;
      user: AppUser;
      url?: string;
    };
  }>()
);
export const verifyAuthTokenFailureAction = createAction(
  '[Users] Verify Auth Token Failure Action',
  props<{
    failure: Failure;
  }>()
);

export const UsersActions = {
  /**
   * Actions For Get All Users
   */
  getAllUsers: getAllUsersAction,
  getAllUsersSuccess: getAllUsersSuccessAction,
  getAllUsersFailure: getAllUsersFailureAction,

  /**
   * Actions For Send Link
   */
  sendLink: sendLinkAction,
  sendLinkSuccess: sendLinkSuccessAction,
  sendLinkFailure: sendLinkFailureAction,

  /**
   * Actions For Upload File
   */
  uploadFile: uploadFileAction,
  uploadFileSuccess: uploadFileSuccessAction,
  uploadFileFailure: uploadFileFailureAction,
  /**
   * Actions For Get Users Count
   */
  getUsersCount: getUsersCountAction,
  getUsersCountSuccess: getUsersCountSuccessAction,
  getUsersCountFailure: getUsersCountFailureAction,
  /**
   * Actions For Get Users Details
   */
  getUserDetails: getUserDetailsAction,
  getUserDetailsSuccess: getUserDetailsSuccessAction,
  getUserDetailsFailure: getUserDetailsFailureAction,

  /**
   * Actions For Get Users Details
   */
  updateUser: updateUserAction,
  updateUserSuccess: updateUserSuccessAction,
  updateUserFailure: updateUserFailureAction,
  /**
   * Actions For Delete User
   */
  deleteUser: deleteUserAction,
  deleteUserSuccess: deleteUserSuccessAction,
  deleteUserFailure: deleteUserFailureAction,
  /**
   * Actions For Forgot Password
   */
  forgotPassword: forgotPasswordAction,
  forgotPasswordSuccess: forgotPasswordSuccessAction,
  forgotPasswordFailure: forgotPasswordFailureAction,
  /**
   * Actions For Reset Password
   */
  resetPassword: resetPasswordAction,
  resetPasswordSuccess: resetPasswordSuccessAction,
  resetPasswordFailure: resetPasswordFailureAction,
  /**
   * Actions For Update Company Manager
   */
  updateCompanyManager: updateCompanyManagerAction,
  updateCompanyManagerSuccess: updateCompanyManagerSuccessAction,
  updateCompanyManagerFailure: updateCompanyManagerFailureAction,
  /**
   * Actions For Confirm
   */
  confirmAccount: confirmAccountAction,
  confirmAccountSuccess: confirmAccountSuccessAction,
  confirmAccountFailure: confirmAccountFailureAction,
  /**
   * Action For Switch Admin |regular user
   */
  switchToAdmin: switchToAdminAction,
  /**
   * Actions Create Company Manager
   */
  createCompanyManager: createCompanyManagerAction,
  createCompanyManagerSuccess: createCompanyManagerSuccessAction,
  createCompanyManagerFailure: createCompanyManagerFailureAction,
  /**
   * Actions Resend Email
   */
  resendEmail: resendEmailAction,
  resendEmailSuccess: resendEmailSuccessAction,
  resendEmailFailure: resendEmailFailureAction,
  /**
   * Actions Send Code
   */
  sendCode: sendCodeAction,
  sendCodeSuccess: sendCodeSuccessAction,
  sendCodeFailure: sendCodeFailureAction,
  /**
   * Actions Verify Auth Token
   */
  verifyAuthToken: verifyAuthTokenAction,
  verifyAuthTokenSuccess: verifyAuthTokenSuccessAction,
  verifyAuthTokenFailure: verifyAuthTokenFailureAction,
};
